import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { Banner, Heading, Text } from 'components/chroma';

import ICONS from 'components/Icons';
import { SCREEN } from 'scenes/common/types/screen';
import { insuranceBaseUrl } from 'scenes/common/helpers/contacts';

const Wrapper = styled.div`
  margin-top: 30px;

  @media (min-width: ${SCREEN.SMALL}px) {
    margin-top: 60px;
  }
`;

const NotFoundImage = styled.img`
  height: 8rem;
  width: 100%;
  position: relative;
  z-index: 2;
  top: -14px;

  @media (min-width: ${SCREEN.SMALL}px) {
    height: 14rem;
    top: 48px;
  }
`;

export const ImportantUpdate: FunctionComponent = () => (
  <>
    <Banner width="viewport" padding={0}>
      <NotFoundImage
        src={ICONS.ERROR.NOTFOUND}
        tabIndex={-1}
        alt="Exclamation mark inside red triangle"
      />
    </Banner>
    <Wrapper>
      <Heading>Important Update</Heading>
      <Text>
        Coles Insurance has changed underwriters for its Car, Home and Landlord
        policies.
      </Text>
      <Text>
        From 1 September 2024, Insurance Australia Limited is no longer the
        underwriter for any new Coles Car, Home or Landlord Insurance policies.
      </Text>
      <Text>
        Go to the{' '}
        <a href={insuranceBaseUrl()} target="_blank" rel="noopener noreferrer">
          Coles Insurance website
        </a>{' '}
        for more details.
      </Text>
    </Wrapper>
  </>
);
